import { useState } from "react";

import { useTheme } from "@mui/material";
import Button from "@mui/material/Button";
import ListItem from "@mui/material/ListItem";
import Typography from "@mui/material/Typography";
import { v4 as uuid } from "uuid";

import { deepCopyObject } from "../../utils/helpers";
import Dialog from "../ui/omniDialog";
import DialogActions from "../ui/omniDialogActions";
import DialogContent from "../ui/omniDialogContent";
import DialogMessage from "../ui/omniDialogMessage";
import DialogTitle from "../ui/omniDialogTitle";
import OmniTextField from "../ui/omniTextField";
import WidgetList from "../ui/widgetList";

const PatientGoalsDialog = props => {
  const {
    open,
    dialogTitle = "SMART Goal Tracker",
    dialogMessage = "Update your SMART Goals below then click OK to continue",
    cancelMessage = "Cancel",
    okMessage = "ok",
    maxWidth = "xs",
    fullWidth = true,
    goalData = [],
  } = props;

  const initializeData = theData => {
    let newData = goalData.slice();
    for (let i = 0; i < newData.length; ++i) {
      newData[i]["newReportedValue"] = newData[i].averageSeverity;
    }
    return newData;
  };

  const [newGoalData, setNewGoalData] = useState(initializeData(goalData));

  const handleChange = (newValue, index) => {
    if (newValue >= 0) {
      newGoalData[index].newReportedValue = newValue;
      setNewGoalData(deepCopyObject(newGoalData));
    }
  };

  const onAcceptHandler = () => {
    props.onAccept(newGoalData);
  };

  const onCloseHandler = () => {
    props.onClose();
  };

  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onCloseHandler}
      disableEscapeKeyDown
      maxWidth={maxWidth}
      fullWidth={fullWidth}
    >
      <DialogTitle onClose={onCloseHandler}>{dialogTitle}</DialogTitle>
      <DialogContent>
        {dialogMessage && (
          <DialogMessage sx={{ marginBottom: theme.spacing(2) }}>{dialogMessage}</DialogMessage>
        )}
        <WidgetList>
          {newGoalData.map((goal, index) => {
            return (
              <ListItem
                key={`goal${index}`}
                disableGutters={true}
                sx={{
                  padding: 0,
                  margin: 0,
                  marginBottom: theme.spacing(1),
                  backgroundColor: theme.palette.commonground.main,
                  color: theme.palette.commonground.contrastText,
                  textAlign: "center",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{ marginTop: theme.spacing(1), textAlign: "end", width: "50%" }}
                >
                  {goal.name}
                </Typography>
                <OmniTextField
                  sx={{
                    maxWidth: "126px",
                    marginLeft: theme.spacing(2),
                    marginTop: "12px",
                    width: "50%",
                  }}
                  label={"Value"}
                  name={uuid()}
                  type="number"
                  variant="outlined"
                  value={goal.newReportedValue}
                  onChange={event => handleChange(event.target.value, index)}
                  autofill="off"
                  placeholder={"Value"}
                />
              </ListItem>
            );
          })}
        </WidgetList>
      </DialogContent>
      <DialogActions>
        {cancelMessage && (
          <Button onClick={onCloseHandler} color="secondary" variant="contained">
            {cancelMessage}
          </Button>
        )}
        <Button onClick={onAcceptHandler} color="secondary" variant="contained">
          {okMessage}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PatientGoalsDialog;
